export const ZERO_PLACEHOLDER = '{0}'
export const ONE_PLACEHOLDER = '{1}'
export const TWO_PLACEHOLDER = '{2}'
export const THREE_PLACEHOLDER = '{3}'

export const CATALOG_ID_PLACEHOLDER = '{CATALOG_ID}'
export const CURRENCY_PLACEHOLDER = '{CURRENCY}'
export const LANG_ID_PLACEHOLDER = '{LANG_ID}'
export const PRICE_PLACEHOLDER = '{PRICE}'
export const STORE_ID_PLACEHOLDER = '{STORE_ID}'
